// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3fc0be87","404":"c469221b","498":"20efc46e","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};